(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/widgets/product-links/assets/javascripts/product-links.js') >= 0) return;  svs.modules.push('/widgets/product-links/assets/javascripts/product-links.js'); 'use strict';

var handleClickProduct = function handleClickProduct(clickEvent) {
  clickEvent.preventDefault();
  var clickedEl = clickEvent.currentTarget;
  var productNameEl = clickedEl.querySelector('.product-name');

  if (!productNameEl) {
    return;
  }

  var productName = productNameEl.textContent;
  var event = {
    action: 'Game Chooser',
    category: 'Navigation',
    opt_label: productName
  };
  var url = clickedEl.getAttribute('href');
  svs.components.analytics.trackEvent(event, function () {
    location.href = url;
  });
};

var init = function init(options) {
  if (!options.$el) {
    return;
  }

  var widgetEl = options.$el.get(0);
  var productElements = Array.prototype.slice.call(widgetEl.querySelectorAll('.js-product-links'));
  productElements.forEach(function (el) {
    el.addEventListener('click', handleClickProduct);
  });
};

setGlobal('svs.widget.productLinks.init', init);
 })(window);